import { request } from "./request.js";

export async function get() {
    return await request("/profile", {}, "GET");
}

export async function save(data) {
    return await request("/profile/save", data, "POST", 'form');
}
